import universal from 'react-universal-component';

export default universal(() => import('./Top200QB'));



// WEBPACK FOOTER //
// ./src/app/views/Top200QB/index.js